import { Box, InputBase, Typography } from "@mui/material";

export function InputCreateProject({
  label,
  placeholder,
  onClick,
  mr,
  width,
  parentWidth = "fit-content",
  ...props
}) {
  return (
    <Box mr={mr || ""} width={parentWidth}>
      <Typography
        color={"text.primary"}
        sx={{
          fontSize: "13px",
          fontStyle: "normal",
          lineHeight: "18px",
          mb: "5px",
        }}
      >
        {label}
      </Typography>
      <Box onClick={onClick} width={width || "220px"} className="inputForm">
        <InputBase
          {...props}
          sx={{ fontSize: "13px", width: "100%" }}
          placeholder={placeholder}
        />
      </Box>
    </Box>
  );
}
